module.exports = __webpack_public_path__ + "img/DAVID_CANNON_44-rs.0efa1a70.jpg";